// Minimal, dependency-free scroll-reveal for [data-custom-reveal] elements.
// Used by custom-feature-item.liquid (Why Choose Us / Service Centre cards).
function initCustomScrollReveal() {
  if (!('IntersectionObserver' in window)) return;

  const items = document.querySelectorAll('[data-custom-reveal]:not([data-custom-reveal-bound])');
  if (!items.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.setAttribute('data-custom-reveal-visible', 'true');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  items.forEach((item) => {
    item.setAttribute('data-custom-reveal-bound', 'true');
    observer.observe(item);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomScrollReveal);
} else {
  initCustomScrollReveal();
}

// Re-scan when sections are added/re-rendered in the theme editor.
document.addEventListener('shopify:section:load', initCustomScrollReveal);
